module.exports = __webpack_public_path__ + "a98f67c80557bfac78dfe7db180f1a66.svg";